"use client";

import { createContext, useContext } from "react";

const WatermarkVersionContext = createContext(null);

export function WatermarkVersionProvider({ version, children }) {
  return (
    <WatermarkVersionContext.Provider value={version ?? null}>
      {children}
    </WatermarkVersionContext.Provider>
  );
}

export function useWatermarkVersion() {
  return useContext(WatermarkVersionContext);
}
